import FingerprintJS from '@fingerprintjs/fingerprintjs';

// Persistent cookie-style id as a second signal in case the FingerprintJS
// visitorId changes (browser update, major extension change, etc.).
// localStorage is intentional — temp users need this to survive reloads.
const COOKIE_ID_KEY = 'sitaare_cookie_id';

const getOrCreateCookieId = () => {
  try {
    let id = localStorage.getItem(COOKIE_ID_KEY);
    if (!id) {
      id = crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(COOKIE_ID_KEY, id);
    }
    return id;
  } catch {
    // Private-mode / storage-disabled browsers — fall back to a session-lived id.
    return `nolocalstorage-${Date.now()}`;
  }
};

let fpPromise = null;
const loadFingerprint = () => {
  if (!fpPromise) fpPromise = FingerprintJS.load();
  return fpPromise;
};

// Resolves to { visitorId, cookieId }. IP is attached server-side from the request.
// Cached across calls so repeated signup-form mounts don't re-run the fingerprint.
let cached = null;
export const getFingerprint = async () => {
  if (cached) return cached;
  try {
    const fp = await loadFingerprint();
    const { visitorId } = await fp.get();
    cached = { visitorId, cookieId: getOrCreateCookieId() };
  } catch (err) {
    // Degrade gracefully — if the lib fails, still send the cookieId so the
    // backend can partially dedupe. Backend validates visitorId presence for temp creation.
    console.warn('[fingerprint] fallback:', err?.message);
    cached = { visitorId: null, cookieId: getOrCreateCookieId() };
  }
  return cached;
};
